import { includes } from 'ramda';

import {
  PATH_CONTACT_NEW,
  PATH_CONTACT,
  PATH_CONTACTS,
  PATH_DASHBOARD,
  PATH_EXPENSE_CLONE,
  PATH_EXPENSE_NEW,
  PATH_EXPENSE,
  PATH_EXPENSES,
  PATH_EXPORTS,
  PATH_EXPORTS_CONTACTS,
  PATH_EXPORTS_EXPENSES,
  PATH_EXPORTS_INVOICES,
  PATH_INVOICE_CLONE,
  PATH_INVOICE_EDIT,
  PATH_INVOICE_SHOW,
  PATH_INVOICE,
  PATH_INVOICES_OVERVIEW,
  PATH_ORDER,
  PATH_ROOT,
} from '~/router';

export const appLinks = [
  PATH_CONTACT_NEW,
  PATH_CONTACT,
  PATH_CONTACTS,
  PATH_DASHBOARD,
  PATH_EXPENSE_CLONE,
  PATH_EXPENSE_NEW,
  PATH_EXPENSE,
  PATH_EXPENSES,
  PATH_EXPORTS,
  PATH_EXPORTS_CONTACTS,
  PATH_EXPORTS_EXPENSES,
  PATH_EXPORTS_INVOICES,
  PATH_INVOICE_CLONE,
  PATH_INVOICE_EDIT,
  PATH_INVOICE_SHOW,
  PATH_INVOICE,
  PATH_INVOICES_OVERVIEW,
  PATH_ORDER,
];

const promoLinks = [
  PATH_EXPENSES,
  PATH_INVOICES_OVERVIEW,
  PATH_EXPORTS,
];

export function isInAppRoute() {
  return includes(this.$route.name, appLinks);
}

export function isInPromoRoute() {
  return includes(this.$route.name, promoLinks);
}

export function isPostsRoute() {
  return document.body.classList.contains('posts');
}

export function isHomepageRoute() {
  return this.$route.name === PATH_ROOT;
}
